import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "privacy-statement",
  class: "privacy-statement"
}
const _hoisted_2 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Privacy policy "),
    _createElementVNode("div", _hoisted_1, [
      _createVNode($setup["translation"], {
        translation: $setup.translate($setup.statementKey, { ns: $setup.TranslationNamespaceEnum.formLabels })
      }, {
        "privacy-policy-link-slot": _withCtx(() => [
          _createElementVNode("a", {
            class: "privacy-href",
            href: `${$setup.localeUrlPrefix}/privacy/`,
            target: "_blank"
          }, _toDisplayString($setup.translate($setup.FormLabelKeysEnum.privacyPolicyLinkText, { ns: $setup.TranslationNamespaceEnum.formLabels })), 9 /* TEXT, PROPS */, _hoisted_2)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["translation"])
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}